const Title = () => {
  return (
    <header>
      <h1>Brick Destroyer</h1>
    </header>
  );
};

export default Title;
